<template>
  <div class="admin-page">
    <div class="main-cnt">
      <div class="content-white">
        <div class="content-header ex-input-heading">
          <form class="form-group" @submit.prevent="searchUser">
            <div class="row">
              <div class="col-3">
                <div class="form-input">
                  <label class="form-input-lb fs-16" for="name">
                    {{ $t("user.general.search_user") }}
                  </label>
                  <div class="form-input-cnt">
                    <input type="text"
                      id="name"
                      v-model="search.name"
                      name="name"
                      v-bind:placeholder="$t('place_holder.full_name')"
                      class="form-control fs-16"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>

              <div class="col-3">
                <div class="form-input ex-select" v-show="!utils.isPwResetUser()">
                  <label class="form-input-lb fs-16" for="groupId">
                    {{ $t('group.general.short_name') }}
                  </label>
                  <div class="form-input-cnt">
                    <select2
                      id="group"
                      v-model="search.groupId"
                      class="fs-16" name="group"
                      :options="groupSelectOptions"
                      :settings="selectSettings"
                      @change="selectChangeEvent($event)"
                      @select="selectEvent($event)"></select2>
                  </div>
                </div>
              </div>

              <div class="col-3" v-show="!utils.isPwResetUser()">
                <div class="form-input ex-select">
                  <label class="form-input-lb fs-16" for="groupId">
                    {{ $t('company.general.full_name') }}
                  </label>
                  <div class="form-input-cnt">
                    <select2
                      id="company"
                      v-model="search.companyId"
                      class="fs-16" name="company"
                      :options="selectCompanyOptions"
                      :settings="selectCompanySettings"
                      @change="selectCompanyChangeEvent($event)"
                      @select="selectCompanyEvent($event)"></select2>
                  </div>
                </div>
              </div>

              <div class="col-3">
                <button class="btn btn-search-cir" type="submit" :disabled="submitted">
                  <i class="icon-search-w"></i>
                </button>
              </div>

            </div>
            <div class="row mt-4">
              <div class="col-3">
                <div class="form-input">
                  <label class="form-input-lb fs-16" for="tourNumber">
                    {{ $t('user.general.tour_number') }}
                  </label>
                  <div class="form-input-cnt">
                    <input type="text"
                      id="tourNumber"
                      v-model="search.tourNumber"
                      name="tourNumber"
                      class="form-control fs-16"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>

              <div class="col-3">
                <div class="form-input">
                  <label class="form-input-lb fs-16" for="organizationName">
                    {{ $t('user.general.organization_name') }}
                  </label>
                  <div class="form-input-cnt">
                    <input type="text"
                      id="organizationName"
                      v-model="search.organizationName"
                      name="organizationName"
                      class="form-control fs-16"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="content-body">
          <div class="box-content">
            <div class="row h-100">
              <div class="col-12 h-100">
                <div class="d-flex" v-if="utils.isAdminAndSystemAdmin()">
                  <!-- Add -->
                  <button class="btn btn-pink-53 w160 mr-3" data-toggle="modal" data-target="#addUser" v-show="utils.isSystemAdmin()">
                    <i class="icon-plus-w mr-2"></i>
                    {{ $t('button.add') }}
                  </button>

                  <!-- Edit -->
                  <button v-if="(editObj.ids.length > 0)" class="btn btn-pink-53 w140 mr-3" data-toggle="modal" data-target="#editUser" data-vv-scope="s1" v-show="!utils.isPwResetUser()">
                    <i class="icon-pencil-w mr-2"></i>
                    {{ $t('button.edit') }}
                  </button>

                  <button v-else class="btn btn-gray-53 w140 mr-3" v-show="!utils.isPwResetUser()">
                    <i class="icon-pencil-w mr-2"></i>
                    {{ $t('button.edit') }}
                  </button>

                  <!-- Delete -->
                  <button v-if="deleteObj.ids.length > 0" class="btn btn-pink-53 w140 mr-3" data-toggle="modal" data-target="#deleteUser" data-vv-scope="s2" v-show="utils.isSystemAdmin()">
                    <i class="icon-trash mr-2"></i>
                    {{ $t('button.delete') }}
                  </button>

                  <button v-else class="btn btn-gray-53 w140 mr-3" v-show="utils.isSystemAdmin()">
                    <i class="icon-trash mr-2"></i>
                    {{ $t('button.delete') }}
                  </button>

                  <!-- Reset -->
                  <button v-if="resetPassObj.ids.length > 0" class="btn btn-pink-53 w240 mr-3 fs-16" data-toggle="modal" data-target="#resetPassUser" data-vv-scope="s3">
                    <i class="icon-lock-g mr-2 fs-16"></i>
                    {{ $t('button.reset_pass') }}
                  </button>

                  <button v-else class="btn btn-gray-53 w240 mr-3 fs-16">
                    <i class="icon-lock-g mr-2"></i>
                    {{ $t('button.reset_pass') }}
                  </button>

                  <!-- Reset -->
                  <button v-if="resetSecretKeyObj.ids.length > 0" class="btn btn-pink-53 w240 fs-16" data-toggle="modal" data-target="#resetSecretKeyUser" data-vv-scope="s3">
                    {{ $t('button.reset_secret_key') }}
                  </button>

                  <button v-else class="btn btn-gray-53 w240 fs-16">
                    {{ $t('button.reset_secret_key') }}
                  </button>
                </div>
                <div class="d-flex" v-else></div>

                <div class="block-cnt">

                  <div v-if="alert_success" class="alert alert-success" data-vv-scope="s4">{{ alert_success }}</div>
                  <div v-if="alert_error" class="alert alert-danger" data-vv-scope="s5">{{ alert_error }}</div>

                  <div class="loading" v-if="loading == true" data-vv-scope="s6"></div>

                  <div class="table-admin" v-if="listsUser != null && loading == false" data-vv-scope="s7">
                    <table class="table">
                      <tr>
                        <th style="max-width: 45px; text-align: center;">
                          <label class="checkbox-custom">
                            <input type="checkbox" name="selectAllUser" v-on:change="selectAllUser($event)" ref="selectAllUser" :disabled="utils.isReadOnly()"/>
                            <span class="checkmark"></span>
                          </label>
                        </th>
                        <th style="min-width: 190px;">{{ $t("user.general.username") }}</th>
                        <th style="min-width: 190px;">{{ $t("user.general.full_name") }}</th>
                        <th style="max-width: 90px; min-width: 82px;">{{ $t("company.general.full_name") }}</th>
                        <th style="max-width: 110px;">{{ $t("group.general.name") }}</th>
                        <th style="max-width: 140px">{{ $t("user.general.role") }}</th>
                        <th>{{ $t("user.general.period") }}</th>
                        <th style="min-width: 55px; max-width: 55px;">{{ $t("user.general.secret_key") }}</th>
                        <th style="min-width: 140px;">{{ $t("user.general.tour_number") }}</th>
                        <th style="min-width: 100px;">{{ $t("user.general.organization_name") }}</th>
                      </tr>

                      <tr v-for="item in listsUser" :key="item.id">
                        <td>
                          <label class="checkbox-custom">
                            <input type="checkbox" name="selectUser[]" v-on:change="selectUser($event, item.id)" :value="item.id" ref="selectUser" :disabled="utils.isReadOnly()"/>
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td>{{ item.username }}</td>
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.company_name }}</td>
                        <td>{{ item.group }}</td>
                        <td>{{ item.role }}</td>
                        <td v-html="customPeriod(item.period)"></td>
                        <td style="text-align: center;">{{ item.mfa_registered ? "〇" : "" }}</td>
                        <td>{{ item.tour_number }}</td>
                        <td>{{ item.organization_name }}</td>

                      </tr>
                    </table>
                  </div>

                  <div class="clearfix"></div>

                  <div class="page-block" v-if="lastPage > 1" data-vv-scope="s8">
                    <paginate
                      v-model="page"
                      :page-count="lastPage"
                      :page-range="3"
                      :margin-pages="1"
                      :click-handler="requestPagination"
                      :prev-text="$t('pagination.prev')"
                      :next-text="$t('pagination.next')"
                      :class="''"
                      :container-class="'pagination'"
                      :page-class="'page-item'"
                      :prev-class="'page-item'"
                      :next-class="'page-item'"
                      :page-link-class="'page-link'"
                      :prev-link-class="'page-link'"
                      :next-link-class="'page-link'">
                    </paginate>
                  </div>

                  <div class="clearfix"></div>

                  <div class="no-data" v-if="listsUser == null && loading == false" data-vv-scope="s9">
                    {{ $t('general.no_data') }}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-user-management
      @updateListUser="fetchData"
      @unSlectAllUser="unSlectAllUser">
    </add-user-management>

    <edit-user-management
      :editObj="editObj"
      @updateListUser="fetchData"
      @unSlectAllUser="unSlectAllUser">
    </edit-user-management>

    <reset-pass-user-management
      :resetPassObj="resetPassObj"
      @updateListUser="fetchData"
      @unSlectAllUser="unSlectAllUser">
    </reset-pass-user-management>

    <delete-user-management
      :deleteObj="deleteObj"
      @updateListUser="fetchData"
      @unSlectAllUser="unSlectAllUser">
    </delete-user-management>

    <reset-secret-key-management
      :resetSecretKeyObj="resetSecretKeyObj"
      @updateListUser="fetchData"
      @unSlectAllUser="unSlectAllUser">
    </reset-secret-key-management>

  </div>
</template>

<script>
/* global $ */
import _ from "lodash";
import AddUserManagement from "./Add";
import EditUserManagement from "./Edit";
import DeleteUserManagement from "./Delete";
import ResetPassUserManagement from "./ResetPass";
import ResetSecretKeyManagement from "./ResetSecretKey";

import UserManagementService from "@/services/admin/user.service";
import GroupManagementService from "@/services/admin/group.service";
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";

import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

export default {
  components: {
    AddUserManagement,
    EditUserManagement,
    DeleteUserManagement,
    ResetPassUserManagement,
    ResetSecretKeyManagement,
  },
  name: "ListUserManagement",
  props: {
    alert_success: [String],
    alert_error: [String],
  },
  data() {
    let user = JSON.parse(StorageService.getUser());
    if (user && !Utils.isEmptyArr(user.groups)) {
      user.branch = `(${user.groups[0].branch_code})${user.groups[0].branch_name}`;
      user.company_name = user.groups[0].company_name;
      user.branch_id = user.groups[0].branch_id;
    }
    return {
      loginUser: user,
      search: {
        name: "",
        groupId: "",
        companyId: "",
        tourNumber: "",
        organizationName: "",
      },
      editObj: {
        ids: [],
      },
      deleteObj: {
        ids: [],
      },
      resetPassObj: {
        ids: [],
      },
      resetSecretKeyObj: {
        ids: [],
      },

      groups: [],
      groupSelectOptions: [],
      selectSettings: {
        allowClear: true,
        multiple: false,
        width: "100%",
        theme: "bootstrap",
        placeholder: this.$t("place_holder.group"),
        data: this.groupSelectOptions,
      },
      selectCompanyOptions: [],
      selectCompanySettings: {
        allowClear: true,
        multiple: false,
        width: "100%",
        theme: "bootstrap",
        placeholder: this.$t("place_holder.group"),
        data: this.selectCompanyOptions,
      },
      loading: false,
      submitted: false,
      page: 1,
      lastPage: 0,
      lists: null,
      utils: Utils,
    };
  },
  beforeCreate() {},
  created() {
    this.fetchData();
    this.getAllGroups();
    this.getAllCompanies();
  },
  beforeMount() {},
  mounted() {},
  computed: {
    listsUser: function () {
      this.$forceUpdate();
      if (this.lists && this.lists.length > 0) {
        let _list = [];
        $.each(this.lists, function (key, value) {
          let period = "";
          let sperator = "~";

          if (!Utils.isEmptyStr(value.valid_period_from) && !Utils.isEmptyStr(value.valid_period_to)) {
            period += DateUtils.formatDateDot(value.valid_period_from) + sperator + DateUtils.formatDateDot(value.valid_period_to);
          } else {
            if (!Utils.isEmptyStr(value.valid_period_from)) {
              period += DateUtils.formatDateDot(value.valid_period_from) + sperator;
            }
            if (!Utils.isEmptyStr(value.valid_period_to)) {
              period += sperator + DateUtils.formatDateDot(value.valid_period_to);
            }
          }

          let roleName = value.role_name;
          if (!Utils.isEmptyStr(value.role_id)) {
            roleName = UserManagementService.getRoleNameByRoleId(value.role_id);
          }

          let text = "";
          if (!Utils.isEmptyStr(value.branch_name)) {
            text += value.branch_name;
          }
          if (!Utils.isEmptyStr(value.department_name)) {
            text += "・" + value.department_name;
          }
          if (!Utils.isEmptyStr(value.group_name)) {
            text += "・" + value.group_name;
          }

          let item = {
            id: value.id,
            username: value.username,
            full_name: value.full_name,
            company_name: value.company_name,
            group: text,
            role: roleName,
            period: period,
            mfa_registered: value.mfa_registered,
            tour_number: value.tour_number,
            organization_name: value.organization_name,
          };
          _list.push(item);
        });
        return _list;
      } else {
        return null;
      }
    },
  },
  watch: {
    $route() {
      this.fetchData();
      this.getAllGroups();
      this.getAllCompanies();
    },
  },
  methods: {
    fetchData: function fetchData() {
      this.$forceUpdate();
      this.loading = true;
      this.submitted = true;

      let _page = this.$route.query.page;
      if (Utils.isEmptyStr(_page)) {
        _page = this.page;
      }

      UserManagementService.listUser(this.search, _page)
        .then(response => {
          if (response.status == 423) {
            StorageService.saveExpired();
            AuthService.doLogout();
          }
          if (response.status == 200 && response.data.rows.length > 0) {
            this.lists = response.data.rows;
            this.lastPage = response.data.last_page;
            this.page = response.data.current_page;
          } else {
            this.lists = null;
            this.lastPage = 0;
            this.page = 1;
          }
          this.loading = false;
          this.submitted = false;
        })
        .catch((error) => {
          this.loading = false;
          this.submitted = false;
        });

      return false;
    },

    searchUser: function searchUser(event) {
      event.preventDefault();
      this.resetData();
      this.fetchData();
      return false;
    },

    selectUser: function selectUser(event, id) {
      event.preventDefault();
      let _ids = [];
      $.each(this.$refs.selectUser, function (key, elm) {
        if (elm.checked) {
          _ids.push(elm.value);
        }
      });
      this.deleteObj.ids = _ids;
      this.editObj.ids = _ids;
      this.resetPassObj.ids = _ids;
      this.resetSecretKeyObj.ids = _ids;

      if (_ids.length <= 0) {
        if (!Utils.isEmptyStr(this.$refs.selectAllUser)) {
          this.$refs.selectAllUser.checked = false;
        }
      }

      if (this.lists && _ids.length == this.lists.length) {
        if (!Utils.isEmptyStr(this.$refs.selectAllUser)) {
          this.$refs.selectAllUser.checked = true;
        }
      }

      return false;
    },

    selectAllUser: function selectAllUser(event) {
      event.preventDefault();
      let _ids = [];

      if (event.target.checked) {
        $.each(this.$refs.selectUser, function (key, elm) {
          elm.checked = true;
          _ids.push(elm.value);
        });
      } else {
        $.each(this.$refs.selectUser, function (key, elm) {
          elm.checked = false;
        });
        _ids = [];
      }

      this.editObj.ids = _ids;
      this.deleteObj.ids = _ids;
      this.resetPassObj.ids = _ids;
      this.resetSecretKeyObj.ids = _ids;

      return false;
    },

    unSlectAllUser: function unSlectAllUser() {
      if (!Utils.isEmptyArr(this.$refs.selectUser)) {
        $.each(this.$refs.selectUser, function (key, elm) {
          elm.checked = false;
        });
      }

      if (!Utils.isEmptyStr(this.$refs.selectAllUser)) {
        this.$refs.selectAllUser.checked = false;
      }

      this.deleteObj.ids = [];
      this.resetPassObj.ids = [];
      this.editObj.ids = [];
      this.resetSecretKeyObj.ids = [];
    },

    resetData: function resetData() {
      this.loading = false;
      this.submitted = false;
      this.page = 1;
      this.lastPage = 0;
      this.lists = null;
      this.unSlectAllUser();
    },

    getAllGroups: function getAllGroups() {
      const branchId = this.loginUser.branch_id;
      GroupManagementService.getAllGroups()
        .then(response => {
          if (response.status == 423) {
            StorageService.saveExpired();
            AuthService.doLogout();
          }
          if (response.status == 200 && response.data) {
            let selectGroups = [];
            $.each(response.data, function (key, value) {
              if (Utils.isEmptyStr(value.branch_name) && Utils.isEmptyStr(value.department_name) && Utils.isEmptyStr(value.name)) {
                return true;
              }

              if (Utils.isAdmin() && value.branch_id != branchId) {
                return true;
              }

              let text = "";
              if (!Utils.isEmptyStr(value.branch_name)) {
                text += value.branch_name;
              }
              if (!Utils.isEmptyStr(value.department_name)) {
                text += "・" + value.department_name;
              }
              if (!Utils.isEmptyStr(value.name)) {
                text += "・" + value.name;
              }

              let item = {
                id: value.id,
                text: text,
                company_id: value.company_id,
              };

              selectGroups.push(item);
            });

            this.groupSelectOptions = selectGroups;
            this.groups = selectGroups;
          } else {
            this.groupSelectOptions = [];
            this.groups = [];
          }
        })
        .catch((error) => {
          this.groupSelectOptions = [];
          this.groups = [];
        });
      return false;
    },

    getAllCompanies: function getAllCompanies() {
      GroupManagementService.getAllCompanies()
        .then(response => {
          if (response.status == 423) {
            StorageService.saveExpired();
            AuthService.doLogout();
          }
          if (response.status == 200 && response.data) {
            let selectCompanies = [];
            $.each(response.data, function (key, value) {
              if (Utils.isEmptyStr(value.id) || Utils.isEmptyStr(value.name)) {
                return;
              }

              let item = {
                id: value.id,
                text: value.name,
              };

              selectCompanies.push(item);
            });

            this.selectCompanyOptions = selectCompanies;
          } else {
            this.selectCompanyOptions = [];
          }
        })
        .catch((error) => {
          this.selectCompanyOptions = [];
        });
      return false;
    },

    selectChangeEvent(val) {},

    selectEvent({ id, text }) {},

    selectCompanyChangeEvent(val) {
      if (Utils.isEmptyStr(val)) {
        this.groupSelectOptions = this.groups;
        return;
      }

      const _groupRefer = _.filter(this.groups, function (n) {
        return n.company_id == val;
      });
      this.groupSelectOptions = _groupRefer;
    },

    selectCompanyEvent({ id, text }) {},

    requestPagination: function requestPagination(pageNum) {
      /*
              if(pageNum > 1) {
                  this.$router.push({path: '/admin/users', query: {page: pageNum}});
              } else {
                  this.$router.push({path: '/admin/users'});
              }
              */
      // this.page = pageNum;
      this.resetData();
      this.page = pageNum;
      this.fetchData();
      return false;
    },
    customPeriod (strPeriod) {
      let str = strPeriod;
      const reg = /~\d{1,}/g;
      if (reg.test(str)){
        str = str.replace("~", "<br>　~");
      };
      return str;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/UserManagement/List.vue